import Typography from '@mui/material/Typography';
import React from 'react';

import { EmphasisColorMap } from './typography.const';
import { TypographyProps } from './typography.types';

/**
 * @deprecated Use `Body` from `common/src/components/TypographyV2` (e.g. `<Body size="small">`).
 */
export const Body2: React.FC<TypographyProps> = ({ className, emphasis = 'high', ...props }) => {
  return (
    <Typography
      variant="body2"
      className={className}
      color={EmphasisColorMap[emphasis]}
      {...props}
    />
  );
};
